<template>
  <div class="app-phone-field">
    <label for="phone-input" class="label-floating">{{ label }}</label>
    <VueTelInput id="phone-input"
                 :model-value="value"
                 :inputOptions="{ placeholder: placeholder, showDialCode: true }"
                 :defaultCountry="defaultCountry"
                 :disabled="disabled"
                 :class="{ 'border-errored': errorMessages.length }"
                 v-bind="$attrs"
                 style="height: 40px;"
    >
    </VueTelInput>
    <div v-for="(errorMessage, index) in errorMessages" :key="index"
         class="text-text-danger text-caption mt-2 ml-2">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
/**
 * A wrapper around vue-tel-input with default styling and custom default behavior
 * @see https://github.com/iamstevendao/vue-tel-input
 */
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

export default {
  name: 'AppPhoneField',
  inheritAttrs: false,
  components: { VueTelInput },
  props: {
    /**
     * @model
     * The input’s value
     */
    value: {
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    /**
     * The input’s placeholder
     * @default ''
     */
    placeholder: {
      default: '',
    },
    /**
     * The input’s default country
     * @default 'FR'
     */
    defaultCountry: {
      default: 'FR',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import "@/scss/border-tokens";

  .app-phone-field {
    position: relative;

    .label-floating {
      position: absolute;
      top: 0;
      left: 55px;
      padding-left: 3px;
      padding-right: 3px;
      transform: translateY(-50%);
      font-size: 10px;
      color: rgb(var(--v-theme-text-primary));
      background-color: white;
    }

    .border-errored {
      border-color: rgb(var(--v-theme-border-danger));
    }

    .vti__dropdown-list.below {
      top: auto;
      bottom: 100%;
    }

    .vue-tel-input {
      box-shadow: none;
      --outline-color: rgb(var(--v-theme-border-secondary));
      --outline-width: #{get-width('border-width-1')};
      --text-color: rgb(var(--v-theme-text-secondary));

      border-color: var(--outline-color);
      border-width: var(--outline-width);

      &:focus-within {
        --outline-color: rgb(var(--v-theme-border-info-bold));
        --outline-width: #{get-width('border-width-2')};
      }

      &.border-errored {
        --outline-color: rgb(var(--v-theme-border-danger-bold));
      }

      .vti__input {
        color: var(--text-color);
      }
    }
  }
</style>
